import { render, staticRenderFns } from "./CompanyPage.vue?vue&type=template&id=742353e2&scoped=true"
import script from "./CompanyPage.vue?vue&type=script&lang=js"
export * from "./CompanyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742353e2",
  null
  
)

export default component.exports